// All API routes include their own /api prefix. Accept either an origin
// or an /api base from deployment configuration without repeating the prefix.
export function normalizeApiBaseUrl(configuredUrl?: string): string {
  const base = (configuredUrl || 'http://localhost:8000').trim().replace(/\/+$/, '');
  if (base === '/api' || base === '') return '';
  if (/^https?:\/\//i.test(base)) {
    const url = new URL(base);
    const path = url.pathname.replace(/\/+$/, '').replace(/\/api$/, '');
    return `${url.origin}${path}`;
  }
  return base.replace(/\/api$/, '');
}

export const API_BASE_URL = normalizeApiBaseUrl(process.env.REACT_APP_API_URL);
